export default __webpack_public_path__ + "static/media/illustration-depannage.194dc7dd.png";